module.exports = __webpack_public_path__ + "img/circle_num_3_red.f36a8fc7.svg";